<template>
  <textarea class="form-control"
            :id="id"
            v-model="model"
            :placeholder="!disabled ? placeholder : ''"
            :disabled="disabled"></textarea>
</template>

<script>
import autosize from 'autosize';

export default {
  props: {
    value: {
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    id: {
      type: String,
      default: null,
    },

    placeholder: {
      type: String,
      default: null,
    },

    autosize: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    if (this.autosize) {
      this.$nextTick(() => autosize(this.$el), 1000);
    }
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
